<template>
  <div>
    <v-expansion-panel-header
      class="pa-0 ma-0 app-list-card-expansion-header"
      v-if="trip"
    >
      <div class="d-flex algin-center justify-center justify-space-between">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="text-caption mr-1 font-weight-bold"
              v-if="trip.reference_number"
              v-bind="attrs"
              v-on="on"
            >
              {{ trip.reference_number }}
            </span>
          </template>
          <span class="text-capitalize">reference number</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-chip
                class="mr-1 text-capitalize font-weight-bold"
                :class="$helper.tripStatusColor(trip.status, true)"
                x-small
                v-if="trip.status"
                v-bind="attrs"
                v-on="on"
              >
                {{ trip.verbose_status }}
              </v-chip>
            </div>
          </template>
          <span class="text-capitalize"> {{ statusMapping.tripStatus }} </span>
        </v-tooltip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="px-0 py-2" v-if="trip">
      <v-row no-gutters @click="onSelectTrip(trip)">
        <v-col cols="6" class="pb-1">
          <TripTooltipWithIcon
            v-if="trip.driver"
            icon="mdi-account"
            :text="trip.driver"
            :label="`${fleetModule.driver} name`"
          />
        </v-col>
        <v-col cols="6" class="text-right pb-1">
          <TripTooltipWithIcon
            v-if="trip.trip_date"
            icon=" mdi-calendar-range"
            :text="trip.trip_date"
            :label="`${tripModule.trip} date`"
          />
        </v-col>
        <v-col cols="6" class="pb-1">
          <TripTooltipWithIcon
            v-if="trip.driver_contact_number"
            icon="mdi-phone"
            :text="trip.driver_contact_number"
            :label="`${fleetModule.driver} contact number`"
          />
        </v-col>
        <v-col cols="6" class="pb-1 text-right">
          <TripTooltipWithIcon
            v-if="trip.vehicle"
            icon="mdi-truck"
            :text="trip.vehicle"
            :label="`${fleetModule.vehicle} Number`"
          />
        </v-col>

        <v-col cols="12" class="d-flex align-center">
          <TripTooltipWithIcon
            v-if="trip.volume"
            icon="mdi-package-variant-closed"
            :text="trip.volume"
            :label="`${tripModule.trip} volume`"
          />
          <span class="mr-6"></span>
          <TripTooltipWithIcon
            v-if="trip.weight"
            icon="mdi-weight"
            :text="trip.weight"
            :label="`${tripModule.trip} weight`"
          />
        </v-col>
        <v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                label
                x-small
                color="error"
                v-bind="attrs"
                v-on="on"
                class="mr-2 px-2"
              >
                <b class="text-capitalize">{{ trip.type }}</b>
              </v-chip>
            </template>
            <span>Trip Type</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="trip.round_trip"
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="mr-2 px-2"
              >
                mdi-rotate-3d-variant
              </v-icon>
            </template>
            <span>Round Trip</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <!-- <div class="app-relative">
                <v-chip
                  class="px-2 text-capitalize font-weight-bold"
                  x-small
                  v-if="trip.status == 'unallocated' && trip.has_recommendation"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  style="position: absolute; right: 0; bottom: 0"
                  @click.prevent.stop="$emit('tiaRecommendation', trip)"
                >
                  recommend
                </v-chip>
                
              </div> -->
              <v-avatar
                size="20"
                v-bind="attrs"
                v-on="on"
                tile
                v-show="trip.status == 'unallocated' && trip.has_recommendation"
                @click.prevent.stop="$emit('tiaRecommendation', trip)"
              >
                <v-img contain :src="TiaLogo" alt="tia" />
              </v-avatar>
            </template>
            <span class="text-capitalize"> Tia Recommendation </span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import { fleetModule, tripModule, statusMapping } from "@/utils/moduleMapping";
import TiaLogo from "@/assets/Tia_logo.png";

export default {
  components: {
    TripTooltipWithIcon,
  },
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      statusMapping,
      TiaLogo,
      tripModule,
      fleetModule,
    };
  },
  methods: {
    onSelectTrip(trip) {
      this.$emit("selectedTrip", trip.id);
      this.$emit("onSelectedTrip", trip);
    },
  },
};
</script>
